import type { PredicateValue } from '@/entities/predicate';

/** Данные участника, которых хватает строке состава: справочник пользователей за ней не стоит */
export type UserGroupMemberValue = {
  id: number;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  email: string;
  role?: { code: string; name: string } | null;
  isActive: boolean;
};

/** Оставляет только то, что показывает строка состава: источники разные, хранимый вид один */
export const toUserGroupMember = (user: UserGroupMemberValue): UserGroupMemberValue => ({
  id: user.id,
  firstName: user.firstName,
  middleName: user.middleName ?? null,
  lastName: user.lastName,
  email: user.email,
  role: user.role ?? null,
  isActive: user.isActive,
});

export type UserGroupFromValues = {
  name: string;
  predicate: PredicateValue;
  users?: UserGroupMemberValue[];
};
